import i18n from "dev/lang";

function $t(key) {
	return i18n.t(key);
}


export default {
	roles: [
		{id: 0, text: "admin", rule: "admin"},
		{id: 1, text: "admin", rule: "admin"},
		{id: 2, text: $t("attributes.manager"), rule: "manager"},
		{id: 3, text: $t("attributes.clerk"), rule: "manager"},
		{id: 4, text: $t("pages.measurementTable.surveyer"), rule: "surveyor"},
		{id: 5, text:$t("attributes.companyManager"), rule: "client"},
		{id: 6, text: $t("attributes.surveyReceptioninst"), rule: "client"},
		{id: 7, text: $t("attributes.manager") + " " + $t("pages.projectForm.branch"), rule: "client"},
		{id: 8, text: $t("attributes.Receptionist"), rule: "client"},
	],
	rules: {
		admin: {route: "admin", appName:"title"},
		manager: {route: "admin", appName:"title"},
		surveyor: {route: "surveyor", baseUrl: "api/surveyors", appName:"title"},
		client: {route: "client", baseUrl: "api/clients", needClient: true, appName:"הזמנת לקוח"}
	}
};
